import { Property as PropertyType } from "src/context/Property/Builder/PropertyBuilder";
import { MultiProperty } from "./PropertyType/Multi";
import { GroupProperty } from "./PropertyType/Group";
import { ValueSwitchContainer } from "./PropertyType/ValueSwitch";

type PropertyProps = {
    startProperty: PropertyType | undefined;
    endProperty: PropertyType | undefined;
};
export const Property = (props: PropertyProps) => {
    // Ideally this would be `ActionProperty` since it looks at the fact
    // that we aim at 2 different Property.
    const { endProperty, startProperty } = props;

    if (endProperty?.type === "multi" && startProperty?.type === "multi") {
        return <MultiProperty startProperty={startProperty} endProperty={endProperty} />;
    }
    if (endProperty?.type === "group" && startProperty?.type === "group") {
        return <GroupProperty startProperty={startProperty} endProperty={endProperty} />;
    }
    if (endProperty?.type === "value" && startProperty?.type === "value") {
        return <ValueSwitchContainer startProperty={startProperty} endProperty={endProperty} />;
    }

    return <>NotHandled</>;
};
